import { useEffect, useState } from "react"

export function useIntersectionObserver(ref) {
		const [animate, setAnimate] = useState(false)
		useEffect(() => {
			const observer = new IntersectionObserver((entries) => {
				entries.forEach((entry) => {
					if (entry.isIntersecting && entry.intersectionRatio >= 0.05) setAnimate(true)
				})
			}, { threshold: 0.05 })
			const { current } = ref
			if (current) observer.observe(current)
			return () => {
				if (current) observer.unobserve(current)
			}
		}, [ref])
		return animate
}

export function useUnsetGrid(ref) {
	useEffect(() => {
		ref.current?.parentElement.classList.add(`unset__grid`);
	}, [ref])
}
